<template>
  <div v-if="allowed || restrict">
    <v-select
      v-if="type === 'OPEN_PAGE' || restrict"
      v-model="defaultLink.path"
      :items="items"
      label="Path"
      :clearable="restrict && restrict.indexOf('_MENU') > 0"
      :rules="
        restrict && restrict.indexOf('_MENU') > 0 ? [] : [formRules.required]
      "
    />
    <v-text-field
      v-else
      v-model="defaultLink.path"
      label="URL"
      :rules="rules"
    />
  </div>
</template>

<script>
import { db } from "../plugins/firebase";
import { appMapSuffix } from "../config/constants";

export default {
  model: {
    prop: "link"
  },
  props: {
    link: Object,
    type: String,
    restrict: {
      type: String,
      validator: value =>
        ~["APP_MAP", "THEME", "SIDE_MENU", "TOP_MENU", "BOTTOM_MENU"].indexOf(
          value
        )
    },
    language: String
  },
  data: () => ({
    defaultLink: {
      connector: null,
      path: null
    },
    appMap: null,
    appMaps: []
  }),
  firestore: {
    appMaps: db.collection("appMaps")
  },
  created() {
    this.$bind(
      "appMap",
      db
        .collection("appMaps")
        .doc((this.$route.params.language || this.language) + appMapSuffix)
    );
    if (this.link) {
      this.defaultLink = {
        ...this.link
      };
    }
  },
  computed: {
    allowed() {
      return ~[
        "PLAY_YOUTUBE",
        "LAUNCH_URL",
        "OPEN_PAGE",
        "OPEN_BROWSER",
        "POST"
      ].indexOf(this.type);
    },
    items() {
      if (this.restrict === "APP_MAP") {
        return this.appMaps.map(appMap => ({
          value: "appMaps/" + appMap.id,
          text: appMap.name
        }));
      } else if (this.restrict === "THEME") {
        return this.appMaps
          .reduce((appMapItems, appMap) => {
            appMapItems.push(...Object.entries(appMap.items));
            return appMapItems;
          }, [])
          .filter(([, value]) => value.type === this.restrict)
          .map(([id, value]) => ({
            value: id,
            text: value.name
          }));
      }
      if (!this.appMap) {
        return [];
      }
      if (this.restrict && this.restrict.indexOf("_MENU") > 0) {
        return Object.entries(this.appMap.items)
          .filter(([, value]) => value.type === this.restrict)
          .map(([id, value]) => ({
            value: id,
            text: value.name
          }));
      } else {
        return Object.entries(this.appMap.items)
          .filter(([, value]) =>
            [
              "DETAILS_PAGE",
              "CARD_PAGE",
              "CONTENT_PAGE",
              "LIST_PAGE",
              "SLIDE_PAGE"
            ].includes(value.type)
          )
          .map(([id, value]) => ({
            value: id,
            text: value.name
          }));
      }
    },
    rules() {
      const rules = [this.formRules.required];
      const otherRules = [];
      if (this.type === "PLAY_YOUTUBE") {
        otherRules.push(this.formRules.YT);
      } else if (this.type === "OPEN_BROWSER") {
        otherRules.push(this.formRules.URL);
      }
      return [...rules, ...otherRules];
    }
  },
  watch: {
    type(value) {
      if (value === "NONE") {
        this.$emit("clearLink");
      } else {
        this.setConnector();
        this.defaultLink.path = null;
      }
    },
    defaultLink: {
      handler(value) {
        if (value.path) {
          this.setConnector();
          this.$emit("input", value);
        } else {
          this.$emit("clearLink");
        }
      },
      deep: true
    }
  },
  methods: {
    setConnector() {
      if (
        ~["PLAY_YOUTUBE", "LAUNCH_URL", "OPEN_BROWSER", "POST"].indexOf(
          this.type
        )
      ) {
        this.defaultLink.connector = "REST";
      } else {
        this.defaultLink.connector = "FIREBASE_FIRESTORE";
      }
    }
  }
};
</script>
